export default __webpack_public_path__ + "static/media/e-met-logotype-l.8dc0396a.svg";